import { defineMessages } from 'react-intl.macro';

const messages = defineMessages({
    pageHeading: {
        id: 'errorPage.pageHeading',
        description: 'Page heading',
        defaultMessage: '404 Error',
    },
    pageNotFound: {
        id: 'errorPage.pageNotFound',
        description: 'H2 level message',
        defaultMessage: 'Page not found',
    },
    pageAdvice: {
        id: 'errorPage.pageAdvice',
        description: 'Suggestion of what to do',
        defaultMessage: 'Please contact your instructor.',
    },
});

export default messages;
